// extracted by mini-css-extract-plugin
export default {"select":"Select_select__aeuTF","selectPopup":"Select_selectPopup__A8LDJ"};